
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.472.809a2.762 2.762 0 00-3.905 0L1.62 11.755a.613.613 0 00-.158.27l-1.44 5.197a.613.613 0 00.755.756l5.198-1.44a.614.614 0 00.27-.157L17.192 5.434a2.764 2.764 0 000-3.905l-.72-.72zM2.957 12.154l8.96-8.959 2.889 2.89-8.96 8.959-2.89-2.89zm-.578 1.158l2.309 2.309-3.193.885.884-3.194zm13.946-8.746l-.651.65-2.89-2.889.651-.65a1.534 1.534 0 012.17 0l.72.72c.598.6.598 1.57 0 2.169z","fill":"currentColor"}})])
          )
        }
      }
    